/* unplugin-vue-components disabled */import { render } from "./ProductList.vue?vue&type=template&id=696231f2&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=696231f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696231f2"]])

export default __exports__